export default {
    MODAL_GENERATE_ROOT_OPERATION_BALANCE_SAVE: 'modalGenerateRootOperationBalanceSave',
}